import React, { useEffect, useState } from "react";
import RenderBannerByLayout from "../../components/RenderBannerByLayout";
import Html from "../Html";

const RightBannerItem = ({ rightBanner }) => {
  const [BannerImages, setBannerImages] = useState();
  const [BannerScript, setBannerScript] = useState();
  useEffect(() => {
    if (rightBanner) {
      // console.log("rightBanner", rightBanner);
      if (rightBanner?.banner_upload_type == "0") {
        // it is array of image
        setBannerImages(rightBanner?.banner_image);
      } else if (rightBanner?.banner_upload_type == 1) {
        // it is script
        setBannerScript(rightBanner?.banner_script);
      } else if (rightBanner?.banner_upload_type == 2) {
        // it is html
        setBannerScript(rightBanner?.banner_html);
      }
    }
  }, [rightBanner]);

  return (
    <section className="pb-4">
      <div className="">
        {BannerScript && (
          <div className="post-is-script">
            <Html html={BannerScript} />
          </div>
        )}
        {BannerImages && <RenderBannerByLayout itemsArray={BannerImages} />}
      </div>
    </section>
  );
};

export default RightBannerItem;
